export default {
  getInvoices(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/invoice-nfe?${queryString}`)
        .then(({ data: { count, next, previous, results } }) => {
          context.commit("setInvoices", results);
          context.commit("setPagination", {
            count,
            next,
            previous
          });
          resolve({ count, next, previous, results });
        })
        .catch(reject);
    });
  },
  getDetailsCSV(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/invoice-nfe/${params.id}?${queryString}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  getInvoicesCSV(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/invoice-nfe?${queryString}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  },
  putInvoices(context, params) {
    return new Promise((resolve, reject) => {
      return window.axios
        .put(`/invoice-nfe/${params.id}`, params)
        .then(resolve)
        .catch(reject);
    });
  },
  getInvoicesTotal(context, params) {
    return new Promise((resolve, reject) => {
      const queryString = new URLSearchParams(params).toString();
      return window.axios
        .get(`/invoice-nfe/totals?${queryString}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(reject);
    });
  }
};
